import { setCurrentSeer } from './proxify-state'

/**
 * @param {!Object} derivable
 * @param {Object} [instance]
 * @param {Array<string>} [propKeys]
 * @param {!guest.maurice.ISeer} [seer]
 */
export const deriveValues = (derivable,instance,propKeys,seer)=>{
  const derivedValues = {}
  const descs = Object.getOwnPropertyDescriptors(derivable)
  let actualDescs = {}
  if (propKeys) {
    for (const pk of propKeys) {
      actualDescs[pk] = descs[pk]
    }
  } else {
    actualDescs = descs
  }
  for (const k in actualDescs) {
    const prop = descs[k]
    try {
      if (seer) setCurrentSeer(seer, k)
      const res = instance ? prop.get.call(instance) : prop.get()
      if (res!==undefined)derivedValues[k]=res
    } finally {
      if (seer) setCurrentSeer(null)
    }
  }
  return derivedValues
}